import PatientsMonitoringStep2 from "../patientsMonitoring/PatientsMonitoringStep2";

export default PatientsMonitoringStep2;
